import { Reveal } from './Reveal.tsx';
import { useCountUp } from '../../hooks/useCountUp.ts';
import { getIcon } from '../../lib/icons.ts';
import type { SiteConfig, StatItem } from '../../siteContentTypes.ts';

function StatCard({ stat }: { stat: StatItem }) {
  const { ref, value } = useCountUp(stat.value);
  const Icon = getIcon(stat.icon);
  return (
    <div ref={ref} className="card" style={{ textAlign: 'center', padding: '28px 16px', flex: '1 1 200px' }}>
      <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 10 }}>
        <Icon size={22} color={stat.color} />
      </div>
      <div style={{ fontSize: 36, fontWeight: 800, color: stat.color }}>
        {stat.prefix}
        {value.toLocaleString('fr-FR')}
        {stat.suffix}
      </div>
      <div style={{ fontSize: 13.5, fontWeight: 700, color: 'var(--text-secondary)', marginTop: 6 }}>{stat.title}</div>
      {stat.description && (
        <div style={{ fontSize: 12, color: 'var(--text-tertiary)', marginTop: 4 }}>{stat.description}</div>
      )}
    </div>
  );
}

export function Statistics({ config }: { config: SiteConfig }) {
  const items = config.statistics.items.filter((s) => s.visible).sort((a, b) => a.order - b.order);
  if (items.length === 0) return null;

  return (
    <section style={{ padding: '48px 24px', maxWidth: 1160, margin: '0 auto' }}>
      <Reveal>
        <h2 style={{ textAlign: 'center', fontSize: 13, fontWeight: 700, color: 'var(--text-tertiary)', marginBottom: 24 }}>
          {config.statistics.title}
        </h2>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 16 }}>
          {items.map((stat) => (
            <StatCard key={stat.title} stat={stat} />
          ))}
        </div>
      </Reveal>
    </section>
  );
}
